export default __webpack_public_path__ + "static/media/reino-unido.4839cec4.svg";